export class SignUpModel{
    name:string;
    email:string;
    username:string;
    password:string;
    password_confirmation:string;
    recomended_by?:string;
    
    constructor(){

    }
}


// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nmodels/auth/signup.model.ts